import { Modal } from "antd";
import { useAppDispatch } from "core/utils";
import i18n from "i18next";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import type { FormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import { SecondaryButton } from "../../../../../components/Buttons/components/ActionButton";
import { showErrorNotification } from "../../../../../components/NotificationAlerts";

interface AppSchemaImportButtonProps {
    onDataLoaded: (importedData: FormJson) => void;
}

export const AppSchemaImportButton = (props: AppSchemaImportButtonProps) => {
    const { onDataLoaded } = props;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentImportFile, setCurrentImportFile] = useState("");

    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const requestUserImportFile = useCallback(() => {
        setIsModalVisible(true);
    }, [setIsModalVisible]);

    const onOk = useCallback(() => {
        if (currentImportFile) {
            const importedData = JSON.parse(currentImportFile);
            onDataLoaded(importedData);
            if (!importedData) {
                dispatch(
                    showErrorNotification({
                        text: t("error.appConfig.import.badInput"),
                        autoCloseDisabled: true,
                    }),
                );
            }

            setIsModalVisible(false);
        }
    }, [currentImportFile, onDataLoaded, dispatch, t]);

    const onCancel = useCallback(() => {
        setIsModalVisible(false);
    }, [setIsModalVisible]);

    const onSelectedFile = useCallback(
        (ev: React.ChangeEvent<HTMLInputElement>) => {
            const { files } = ev.target;
            const file = files?.item(0);
            if (file) {
                file.text().then((content) => setCurrentImportFile(content));
            }
        },
        [setCurrentImportFile],
    );

    return (
        <>
            <Modal open={isModalVisible} title={t("appConfigs.modal.import.title")} onOk={onOk} onCancel={onCancel}>
                <p>{t("appConfigs.modal.import.message")}</p>
                <input type="file" disabled={false} onChange={onSelectedFile} />
            </Modal>
            <SecondaryButton onClick={requestUserImportFile} disabled={false}>
                {i18n.t("button.import")}
            </SecondaryButton>
        </>
    );
};
